import React, { FC, memo } from 'react';

import { PointsListCheckboxGroupPointType } from 'application/components/PointItemContent/types';

import PointAddressItem from './PointAddressItem';

interface PointAddressesListProps {
  selectedPoints: {
    id: PointsListCheckboxGroupPointType['id'];
    address?: PointsListCheckboxGroupPointType['address'];
    title?: PointsListCheckboxGroupPointType['title'];
  }[];
}

const PointAddressesList: FC<PointAddressesListProps> = ({ selectedPoints }) => (
  <>
    {selectedPoints.map((point) => (
      <PointAddressItem
        key={point.id}
        id={point.id}
        address={point.address}
        title={point.title}
      />
    ))}
  </>
);

export default memo(PointAddressesList);
